import React, { createContext, useEffect, useMemo, useState } from "react";
import { returNombreRuta } from "../utils/funciones";
import { useLocation } from "react-router-dom";
import { getUno } from "../api/apis";
import PropTypes from "prop-types";

export const DataContext = createContext();
export const DataContextContractual = createContext();
export const ContextApi = ({ children }) => {
  const [selectModulo, setSelectModulo] = useState(undefined);
  const [reingresa, setReingresa] = useState(false);
  //e const [listaGuardado, setLista] = useState([]);
  const [visibleNotificaciones, setVisibleNotificaciones] = useState([]);
  const [nombreMenu, setNombreMenu] = useState('');
  const [page, setPage] = useState(0);
  const [objTemporal, setObjTemporal] = useState([]);
  const [uno, setUno] = useState(undefined);
  const [dataObj, setDataObj] = useState(undefined);
  const [notificaciones, setNotificaciones] = useState([]);




  const location = useLocation();
  useEffect(() => {
    setNombreMenu(returNombreRuta(location.pathname));
  }, [location]);

  //e function setListaGuardado(item) { setLista([...listaGuardado, item]); }

  function setearPagina(item) { setPage(item); }

  const data_ = useMemo(() => ({
    visibleNotificaciones, setVisibleNotificaciones, objTemporal, setObjTemporal,
    reingresa, cambioReingresa: setReingresa, // listaGuardado, setListaGuardado,
    page, setearPagina, nombreMenu, notificaciones, setNotificaciones,
    selectModulo, setSelectModulo, dataObj, setDataObj, uno, setUno, setNombreMenu
  }), [
    visibleNotificaciones,
    objTemporal,
    reingresa,
    // listaGuardado,
    page,
    nombreMenu,
    notificaciones,
    selectModulo,
    dataObj,
    uno,
  ])

  return (<DataContext.Provider value={data_}>{children}</DataContext.Provider>)
}

export const ContextContractualApi = ({ children }) => {
  const [dataListado, setDataListado] = useState({ headers: [], id_columnas: [], arrData: [] });
  const [configuracionesDias, setConfiguracionesDias] = useState([]);
  const [diasAnticipo, setDiasAnticipo] = useState(0);
  const [diasAnticipoGeneral, setDiasAnticipoGeneral] = useState(0);
  const [diasAnticipoRenovacion, setDiasAnticipoRenovacion] = useState(0);
  const [tipoSolicitud, setTipoSolicitud] = useState('');
  const [visibleAprobador, setVisibleAprobador] = useState(false);
  const [visibleModalForm, setVisibleModalForm] = useState(false);
  const [dataModalForm, setDataModalForm] = useState({
    titulo: "Cambio de instalación",
    component: (
      <div>esta es la prueba</div>
    ),
  });

  const [visibleEditarModal, setVisibleEditarModal] = useState(false);
  const [solicitudEditar, setSolicitudEditar] = useState(null);
  const hideEditarModal = () => setVisibleEditarModal(false);

  const ObtenerDiasAnticipacion = async () => {
    // Lógica para obtener los días de anticipación
    const resp = await getUno('configuracion', null, null);
    if (resp?.data?.status === "success" && Array.isArray(resp.data.data)) {
      const dataArr = resp.data.data;
      setConfiguracionesDias(dataArr);

      const itemGen = dataArr.find(c => Number(c.id) === 1) || dataArr[0];
      const itemRen = dataArr.find(c => Number(c.id) === 2);

      const valGen = itemGen ? Number(itemGen.dias_anticipacion || 0) : 0;
      const valRen = itemRen ? Number(itemRen.dias_anticipacion || 0) : valGen;

      setDiasAnticipo(valGen);
      setDiasAnticipoGeneral(valGen);
      setDiasAnticipoRenovacion(valRen);
    } else if (resp?.data?.status === "success" && resp.data.data?.dias_anticipacion !== undefined) {
      const val = Number(resp.data.data.dias_anticipacion || 0);
      setDiasAnticipo(val);
      setDiasAnticipoGeneral(val);
      setDiasAnticipoRenovacion(val);
    } else {
      setDiasAnticipo(0);
      setDiasAnticipoGeneral(0);
      setDiasAnticipoRenovacion(0);
    }
  };

  const obtenerDiasAnticipoPorTipo = (tipo) => {
    if (Number(tipo) === 4) {
      return diasAnticipoRenovacion;
    }
    return diasAnticipoGeneral;
  };

  useEffect(() => {
    ObtenerDiasAnticipacion();
  }, []);

  const data = useMemo(() => ({
    dataListado, setDataListado, diasAnticipo, setDiasAnticipo,
    configuracionesDias, setConfiguracionesDias,
    diasAnticipoGeneral, diasAnticipoRenovacion,
    obtenerDiasAnticipoPorTipo, ObtenerDiasAnticipacion,
    tipoSolicitud, setTipoSolicitud,
    visibleAprobador, setVisibleAprobador, visibleModalForm, setVisibleModalForm, dataModalForm, setDataModalForm,
    visibleEditarModal, setVisibleEditarModal, solicitudEditar, setSolicitudEditar, hideEditarModal
  }), [
    dataListado,
    diasAnticipo,
    configuracionesDias,
    diasAnticipoGeneral,
    diasAnticipoRenovacion,
    tipoSolicitud,
    visibleAprobador,
    visibleModalForm,
    dataModalForm,
    visibleEditarModal,
    solicitudEditar,
  ])

  return (
    <DataContextContractual.Provider value={data}>
      {children}
    </DataContextContractual.Provider>
  )
}

ContextApi.propTypes = {
  children: PropTypes.node.isRequired,
};

ContextContractualApi.propTypes = {
  children: PropTypes.node.isRequired,
};